"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightSeatsTariffColumn = exports.getAddon = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const useForm_1 = require("../../../../hooks/useForm");
const Field_1 = require("../../../Form/Field");
const Column_1 = require("../../../TariffsTable/Column");
const tariffGroupMapper_1 = require("../../../TariffsTable/tariffGroupMapper");
const index_1 = require("../index");
const utils_1 = require("./utils");
const getAddon = (key) => {
    const addonMap = {
        totalSeats: undefined,
        costPerSeat: 'CHF',
        agentSeatsLimit: undefined,
        onlineSeatsLimit: undefined,
    };
    return addonMap[key];
};
exports.getAddon = getAddon;
const descriptor = {
    totalSeats: useForm_1.allDescriptors.number({
        restrictions: {
            positiveNumber: true,
            integer: true,
        },
    }),
    costPerSeat: useForm_1.allDescriptors.number({
        restrictions: {
            positiveNumber: true,
            roundedMoney: true,
        },
    }),
    agentSeatsLimit: useForm_1.allDescriptors.number({
        restrictions: {
            positiveNumber: true,
            integer: true,
        },
    }),
    onlineSeatsLimit: useForm_1.allDescriptors.number({
        restrictions: {
            positiveNumber: true,
            integer: true,
        },
    }),
    // Not editable
    allotmentSeats: useForm_1.allDescriptors.number(),
    seatsForSale: useForm_1.allDescriptors.number(),
    tariffGroup: useForm_1.allDescriptors.object(),
};
const FlightSeatsTariffColumn = (props) => {
    var _a;
    const { tariffGroup, config, onChange, setValidateRef } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const defaultValues = (0, react_1.useMemo)(() => ({
        tariffGroup: {
            id: tariffGroup.id,
        },
    }), [tariffGroup]);
    const propsValues = (_a = props.propsValues) !== null && _a !== void 0 ? _a : defaultValues;
    const { fields, validateAll } = (0, useForm_1.useForm)({
        descriptor, config, propsValues, onChange,
    });
    setValidateRef === null || setValidateRef === void 0 ? void 0 : setValidateRef(validateAll);
    const tariff = (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariffGroup.id);
    const createCell = (key) => {
        const { input, onEvent, error, modifiers, disabled } = fields[key];
        const formFieldProps = {
            name: key,
            value: input,
            onChange: onEvent,
            error,
            modificators: modifiers,
            disabled,
            addon: (0, exports.getAddon)(key),
        };
        const content = (react_1.default.createElement("div", { className: `${index_1.className}__cell` },
            react_1.default.createElement(Field_1.FormField, { ...formFieldProps })));
        return { content, tariff };
    };
    const cells = [
        {
            content: tariffGroup.name[locale],
            tariff,
        },
        ...utils_1.seatsTariffOrder
            .filter(key => !fields[key].hidden)
            .map(createCell),
    ];
    return (react_1.default.createElement(Column_1.TariffsTableColumn, { cells: cells }));
};
exports.FlightSeatsTariffColumn = FlightSeatsTariffColumn;
//# sourceMappingURL=TariffColumn.js.map